
import { GET_MATCHED_JOBS_TYPE,SEARCH_APPLY_JOBS } from "../../action/types";

const initialState = {
    data:[],
    message:"",
    error:""
}

export default function(state=initialState,action){
console.log(action)
switch(action.type){
case GET_MATCHED_JOBS_TYPE:
    return {
    ...state,
    data:action.payload
 }
 case SEARCH_APPLY_JOBS:
    return {
    ...state,
    data:action.payload
 }

 case "EMPTY_ARRAY":
    return {
    ...state,
    message:action.payload
 }
 default : return state
}
}